import { Dialog, DialogTitle, DialogContent, Button } from "@material-ui/core";
import { useState } from "react";

export default function Goodbye() {
  const [open, setOpen] = useState(true);
  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle style={{ paddingBottom: "0px" }}>Thanks!</DialogTitle>
      <DialogContent style={{ maxWidth: "300px", marginBottom: "15px" }}>
        As the pandemic has settled, this project will enter maintenance-only
        mode and won't be updated. Thanks for all the support!.
      </DialogContent>
      <Button variant="primary" onClick={() => setOpen(false)}>
        Close
      </Button>
    </Dialog>
  );
}
